<div class="row no-access-header-spacer">
  <div class="col center c-info">
    <fa-icon
      [icon]="faBan"
      size="6x"
      class="u-color--extra-light"></fa-icon>
    <h2 class="u-mt--medium">{{ "noaccess.title" | translate }}</h2>
    <h5 class="u-mt--medium">{{ "noaccess.description" | translate }}</h5>
    <div class="c-info__item u-mt--large">
      {{ "noaccess.goto" | translate }}
      <a routerLink="{{ routeNameConstants.ROOT }}">{{ "noaccess.homepage" | translate }}</a>
    </div>
  </div>
</div>
